var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "a28c0d804d4f14ed8793b91cda3173244fe5f5b6"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["dodo-landing-page@delivery-hero-pm"] = {
  id: "a28c0d804d4f14ed8793b91cda3173244fe5f5b6"
};